import { PayloadAction } from '@reduxjs/toolkit';
import { StringHelpers } from 'helpers/stringHelpers';

export const makePropertyReducer =
  <TState extends Record<string, unknown>>() =>
  <TName extends Extract<keyof TState, string>>(name: TName) =>
    ({
      [`set${StringHelpers.capitalizeFirstLetter(name)}`]: (
        state: TState,
        action: PayloadAction<TState[TName]>,
      ) => {
        state[name] = action.payload;
      },
    }) as {
      [set in `set${Capitalize<TName>}`]: (
        state: TState,
        action: PayloadAction<TState[TName]>,
      ) => void;
    };
